import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@facade/lib/utils";

const indeterminateProgressVariants = cva(
  "relative h-1 w-full overflow-hidden rounded-full",
  {
    variants: {
      variant: {
        brand: "bg-brand-primary/20 [&>div]:bg-brand-primary",
        neutral: "bg-accent [&>div]:bg-accent-foreground/70",
      },
    },
    defaultVariants: {
      variant: "brand",
    },
  },
);

type IndeterminateProgressProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof indeterminateProgressVariants>;

export function IndeterminateProgress({
  className,
  variant,
  ...props
}: IndeterminateProgressProps) {
  return (
    <div
      role="progressbar"
      aria-valuetext="Loading"
      className={cn(indeterminateProgressVariants({ variant }), className)}
      {...props}
    >
      <div className="absolute h-full w-1/3 animate-indeterminate-progress rounded-full" />
    </div>
  );
}
